import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './inicio/inicio.component';
import { LandingComponent } from './landing.component';
import { ReglasComponent } from './reglas/reglas.component';
import { Resultados107Component } from './resultados107/resultados107.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { EstadisticasComponent } from './estadisticas/estadisticas.component';
const routes: Routes = [{
  path : 'landing',
  component : LandingComponent,
  children : [
    { path : "inicio", component : InicioComponent },
    { path : "reglas", component : ReglasComponent },
    { path : "resultados-107", component : Resultados107Component },
    { path : "calendario", component : CalendarioComponent },
    { path : "estadisticas", component : EstadisticasComponent },
    { path: '', redirectTo: '/inicio', pathMatch: 'full'}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
